import { Classes, Divider } from "@blueprintjs/core";
import { PlanrPopover } from "modules/common/components/planr/popover/Popover";
import { observer } from "mobx-react";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { ChangelogType } from "modules/root/models/changelog";
import React from "react";
import styles from "./AppVersion.module.scss";

export const AppVersion = observer(({ version, changelog, prefix }: AppVersionProps) => {
    const last = changelog.length - 1;
    return changelog.length ? (
        <PlanrPopover
            enforceFocus={false}
            isOpen={undefined}
            className="app-version"
            content={
                <div className={`${styles.changelog} ${Classes.ELEVATION_2}`}>
                    {changelog.map((log, index) => (
                        <div key={log.name}>
                            <h3 className={styles.title}>
                                {prefix}
                                {log.name}
                            </h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: log.description,
                                }}
                            />
                            {index < last && <Divider />}
                        </div>
                    ))}
                </div>
            }
        >
            {renderVersion(prefix + version, true)}
        </PlanrPopover>
    ) : (
        renderVersion(prefix + version, false)
    );
});

const renderVersion = (version: string, interactive: boolean) =>
    interactive ? (
        <button type="button" className={styles.version} title="Список изменений">
            <span>v{version}</span>
            <GeneralIcon type="general-chevron-down" size={12} className={styles.chevron} />
        </button>
    ) : (
        <span className={styles.versionStatic}>v{version}</span>
    );

interface AppVersionProps {
    version: string;
    changelog: ChangelogType[];
    prefix: string;
}
